import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
	submit: {
		margin: theme.spacing(2, 0, 2),
		backgroundColor: '#198754',
		color: '#fff',
		fontFamily: 'Poppins',
		'&:hover': {
			backgroundColor: '#198754',
			color: '#fff',
			opacity: 0.8,
		},
	},
	forgetLink: {
		textDecoration: 'none',
		color: '#056333',
		'&:hover': {
			borderBottom: '1px solid #056333',
			opacity: 0.8,
		},
	},
	authText: {
		fontFamily: 'Poppins',
	},
}));

export default useStyles;
